import React, { useEffect, useRef } from 'react';
import { Message } from '../types.ts';
import { socket } from '../socket.ts';
import Reactions from '@charkour/react-reactions';

type Props = {
    messages: Message[];
};

const MessageList: React.FC<Props> = ({ messages }) => {
    const userEmail = socket.io.opts.query.email;

    const handleReact = (messageId: string, emoji: string) => {
        socket.emit('add reaction', {
            messageId,
            email: userEmail,
            emoji,
        });
    };

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [messages]);

    return (
        <div className="message-list" ref={containerRef} style={{ overflowY: 'auto', maxHeight: '100%' }}>
            {messages.map((msg, i) => (
                <div key={i} className="message" style={{ position: 'relative', paddingBottom: 8 }}>
                    <img
                        src={msg.imageUrl || 'https://lavnch.com/wp-content/uploads/2020/12/cropped-lavnch-site-icon.png'}
                        onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.onerror = null;
                            target.src = 'https://lavnch.com/wp-content/uploads/2020/12/cropped-lavnch-site-icon.png';
                        }}
                        alt={msg.name}
                        className="avatar"
                    />
                    <div>
                        <strong>{msg.name}</strong>: {msg.text}

                        <div style={{ marginTop: 4 }}>
                            <Reactions
                                iconSize={20}
                                user={userEmail}
                                reactions={msg.reactions || {}}
                                onSelect={(emoji) => handleReact(msg._id, emoji)}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MessageList;
